import React from 'react'
import {useSelector} from 'react-redux'
import {seoTypeSelector} from '../selectors'

/** @param {import('./SeoBannerImage').SeoBannerImageProps} props */
export default function SeoBannerImage(props) {
    const src = useSelector((state) => seoTypeSelector(state, props.src))
    const alt = useSelector((state) => seoTypeSelector(state, props.alt))

    return (
        <img loading="lazy" src={src} alt={alt} className={props.className} />
    )
}
